import { RoomStateEvent } from 'matrix-js-sdk/src/matrix';
import { useEffect, useState } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

import { Member } from './MembersSection/utils';
import { buildWorkspaceMembersList } from './utils';

const useWorkspaceMembers = () => {
  const [members, setMembers] = useState<Member[]>([]);
  const { matrixClient } = useMatrixContext();
  const { workspaceId, workspaceRoles, roleAssignments } = useWorkspacesContext();

  useEffect(() => {
    if (!workspaceId) {
      setMembers([]);
      return;
    }

    const workspaceRoom = matrixClient.getRoom(workspaceId);
    if (!workspaceRoom) return;

    const loadMembers = () => {
      setMembers(
        buildWorkspaceMembersList({
          roomMembers: workspaceRoom.getMembers(),
          matrixClient,
          workspaceId,
          workspaceRoom,
          workspaceRoles: workspaceRoles ?? [],
          roleAssignments: roleAssignments ?? [],
        })
      );
    };

    loadMembers();

    workspaceRoom.on(RoomStateEvent.Members, loadMembers);
    workspaceRoom.on(RoomStateEvent.Events, loadMembers);

    return () => {
      workspaceRoom.off(RoomStateEvent.Members, loadMembers);
      workspaceRoom.off(RoomStateEvent.Events, loadMembers);
    };
  }, [matrixClient, roleAssignments, workspaceId, workspaceRoles]);

  return members;
};

export default useWorkspaceMembers;
